export default __webpack_public_path__ + "static/media/sticker-R.ad19e8c3.png";